export default function isTooltipDisabled(value, length) {
  const stringValue = String(value);
  return (stringValue === '' || !!stringValue) && stringValue.length <= length;
}
